import moment from 'moment'
import { useTranslation, Trans } from 'react-i18next'
import MenuCard from '@/components/menu-card'
import useBetaUser from '@/hooks/use-beta-user'
import useCurrentSession from '@/hooks/use-current-session'
import { ChatIcon, PaymentsIcon, ContractIcon, ResourcesIcon, NoteIcon } from '@/components/icons'

const TenantMenuCards = ({
  contract,
  unreadCount,
  chatsLinkDisabled,
  paymentsLinkDisabled,
  contractLinkDisabled,
  resourcesLinkDisabled,
  payoutDate
}) => {
  const { t } = useTranslation()
  const listingId = contract.listing_id
  const listingStateMachine = contract.listing_state_machine
  const session = useCurrentSession()
  const betaUser = useBetaUser()
  const betaUserContractLite = betaUser.custom_contract
  const currentBetaUser = betaUserContractLite.includes(parseInt(session.id))

  const contractManagerView = () => {
    if (currentBetaUser) return `/contract/manager/${contract?.listing_contract_id}`
    return `/tenant/${listingId}/contract/${contract?.listing_contract_id}`
  }

  const paymentsText = payoutDate ? (
    <Trans
      i18nKey="l.tenants.view.payments_payout_date.text"
      values={{
        date: moment(payoutDate).format('MMM Do, YYYY')
      }}
      defaults="Payout scheduled for {{ date }}"
    />
  ) : (
    t('l.tenants.view.payments.text', 'Request and receive digital payments')
  )

  const menuItems = [
    {
      title: t('l.tenants.view.tenant_chats.label', 'Tenant Chats'),
      description: t('l.tenants.view.chats.text', 'Reply to tenant messages from this listing'),
      icon: ChatIcon,
      to: `/tenant/${listingId}/chat?filter=tenants&listing_id=${listingId}`,
      count: unreadCount,
      disabled: chatsLinkDisabled
    },
    {
      title: t('l.tenants.view.payments.label', 'Payments'),
      description: paymentsText,
      icon: PaymentsIcon,
      to: `/tenant/${listingId}/payments`,
      disabled: paymentsLinkDisabled
    },
    {
      title: t('l.tenants.view.contract.label', 'Contract'),
      description: t('l.tenants.view.contract.text', 'Access contract history & renew contract'),
      iconId: 'contract',
      icon: ContractIcon,
      to: contractManagerView(),
      disabled: contractLinkDisabled
    },
    {
      title: t('l.tenants.view.other_resources.label', 'More Options'),
      description: t('l.tenants.view.other_resources.text', 'Additional rental documents'),
      icon: ResourcesIcon,
      to: `/tenant/${listingId}/resources`,
      disabled: resourcesLinkDisabled
    },
    listingStateMachine && {
      title: t('l.listing.view.notes.label', 'Notes'),
      description: t(
        'l.listing.view.notes.text',
        'Keep track of each listing using your private notes'
      ),
      icon: NoteIcon,
      to: `/tenant/${listingId}/notes`
    }
  ]

  return (
    <>
      {menuItems.map((item, index) => (
        <MenuCard key={`tenant-card-${index}`} item={item} width="100%" />
      ))}
    </>
  )
}

export default TenantMenuCards
